/* eslint-disable */
import React from 'react';
import _ from 'lodash';
import Modal from 'react-bootstrap/lib/Modal';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import s from './LayersModal.scss';
import Lightbox from './Lightbox';
import { connect } from 'react-redux';
import {
  setCurrentMapComposition,
  setMapLayerVisibility,
  setMapGroupVisibility,
  setLayersArea,
} from '../../../actions/layers';
import { setStartPoint, setEndPoint, changeCenter } from '../../../actions/routing';
import { toggleAdditionals } from '../../../actions/postGeoData';
import zoom_icon from './zoom_icon.png';
import infoIcon from './legend.png';
import checkicon from './Check-icon.png';
import DropCheckbox from './DropCheckbox.js';
import Popup from './Popup.js';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// profile dla CIESZANOWA!
const turysta = ['POI i PUNKTY TURYSTYCZNE', 'PUNKTY NOCLEGOWE', 'KOMUNIKACJA PUBLICZNA'];
const inwestor = ['MPZP', 'DECYZJE ŚU', 'DECYZJE WZ i ULICP', 'SUIKZP', 'EMUIA'];
const ogolny = ['MPZP'];

class LayersModal extends React.Component {
  constructor(props) {
    super(props);
    const composition = _.filter(this.props.district.compositions, o => o.isDefault === true)
      ? _.filter(this.props.district.compositions, o => o.isDefault === true)[0]
      : this.props.district.compositions[0];
    this.state = {
      currentComposition: composition,
      lightboxStatus: false,
      clickedLayer: null,
    };
  }

  onChangeComposition = e => {
    const composition = _.filter(this.props.district.compositions, o => o.nazwa === e);
    let nullComposition = _.concat(composition[0]);
    nullComposition.nazwa = 'null';
    nullComposition.layers = [{ isVisible: false }];
    if (e === this.props.currentComposition.nazwa) {
      this.props.setCurrentMapComposition(nullComposition);
    } else {
      this.props.setCurrentMapComposition(composition[0]);
    }
  };

  getLayerType = layer => {
    // return layer type as string with additional "inGroup string"
    let layerType = '';
    _.filter(this.props.district.layers, o => {
      if (o.name === layer.warstwa) {
        for (const attr of o.attrs) {
          if (attr.nazwa === 'geom') {
            layerType = attr.dataType;
          }
        }
      }
      return o;
    });
    let odp = layerType.toLowerCase().replace('multi', '');
    return layer.grupa ? odp + ' inGroup' : odp;
  };

  /**
   * Sets layer visibility
   * setMapLayerVisibility
   */
  selectLayer = layer => this.props.setMapLayerVisibility(layer);

  /**
   * Sets group visibility
   * setMapGroupVisibility
   */
  selectGroup = group => this.props.setMapGroupVisibility(group);

  toggleAdditionals = layerName => this.props.toggleAdditionals(layerName);

  handleLegendClick = layerName => {
    this.setState({ lightboxStatus: true, clickedLayer: layerName });
  };
  closeLightbox = () => {
    this.setState({ lightboxStatus: false, clickedLayer: null });
  };
  onClickLayersZoom = index => {
    this.props.setLayersArea(index);
  };

  //onClick={()=>this.onClickLayersZoom(_.find(this.props.district.layers, k => k.name === v.warstwa))}

  render() {
    return (
      <div>
        {this.props.currentComposition ? (
          <div
            className={
              this.props.printModalStatus === false ? 'layers-panel-body' : 'panel-body-in-print'
            }
          >
            {this.props.district.compositions.map((v, i) => {

              if (v && this.props.visible_compositions) {
                return this.props.visible_compositions.map((x, j) => {
                  return x.toLowerCase() === v.nazwa.toLowerCase() ? (
                    <div key={i + j} className="flex-compositions">
                      <div style={{ width: '100%', height: '26px' }}>
                        {/* <Popup opisWarstwy="Lorem ipsum dolor sit amet pede. Fusce nisl tristique enim, id arcu. Suspendisse bibendum blandit, quam. Fusce ullamcorper. Suspendisse a." /> */}
                      </div>

                      <div
                        className={
                          this.props.currentComposition.nazwa.toLowerCase() === v.nazwa.toLowerCase()
                            ? 'layers-border activated'
                            : 'layers-border'
                        }
                        key={i}
                      >
                        <div className="radio">
                          <label>
                            <input
                              type="checkbox"
                              onChange={() => this.onChangeComposition(v.nazwa)}
                              checked={
                                this.props.currentComposition.nazwa.toLowerCase() === v.nazwa.toLowerCase() ||
                                (this.props.currentComposition.nazwa.toLowerCase() == 'DECYZJE ŚU'.toLowerCase() &&
                                  v.nazwa.toLowerCase() == 'EMUIA'.toLowerCase())
                              }
                              name="optradio"
                            />
                            <nazwa>
                              {v.nazwa}
                            </nazwa>
                          </label>
                        </div>

                        <button
                          disabled={this.props.currentComposition.nazwa.toLowerCase() !== v.nazwa.toLowerCase()}
                          className="btn btn-default layer-button"
                          value={this.props.currentComposition.nazwa}
                          onClick={() => this.handleLegendClick()}
                        >
                          { this.props.intl.langKeys.legenda }
                        </button>
                      </div>

                      <div className="dropdown">
                        <DropCheckbox
                          disabled={this.props.currentComposition.nazwa.toLowerCase() !== v.nazwa.toLowerCase()}
                          composition={v}
                        />
                      </div>
                    </div>
                  ) : null;
                });
              } else {
                return (
                  <div key={i}>
                    <label className="listObject">
                      <input
                        onChange={() => this.selectGroup(v)}
                        checked={v.isVisible}
                        type="checkbox"
                        className="form-control"
                        name="checkbox"
                        value={v.nazwa}
                      />
                      <span>&nbsp;&nbsp;{v.nazwa}</span>
                    </label>
                  </div>
                );
              }
            })}
          </div>
        ) : (
          <div className="panel-body">
            <p>Brak zadeklarowanych kompozycji mapowych</p>
          </div>
        )}
        {this.state.lightboxStatus ? (
          <Lightbox closeLightbox={this.closeLightbox} layerName={this.state.clickedLayer} />
        ) : null}
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
  postGeoData: state.postGeoData,
  currentComposition: state.layers.currentMapComposition,
  routing: state.routing,
  printModalStatus: state.printSettings.printModalStatus,
  fontSize: state.runtime.fontSize,
  intl: state.intl
});

const mapDispatch = {
  setCurrentMapComposition,
  setMapLayerVisibility,
  setMapGroupVisibility,
  toggleAdditionals,
  setStartPoint,
  changeCenter,
  setEndPoint,
  setLayersArea,
};
//return <input className="form-control" key={i} type="checkbox" value={v.nazwa} />;
export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(LayersModal),
);



// WEBPACK FOOTER //
// src/components/Modals/LayersModal/LayersModal.js